/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents a platform user\'s role within a Case.
 */
export const CaseRoleType = {
    Manager: 1,
    Assistant: 2,
    Auditor: 3
} as const;
export type CaseRoleType = typeof CaseRoleType[keyof typeof CaseRoleType];

